import React from 'react';
import ReactDOM from 'react-dom';
import {App} from "./app";
import {saveProjectAs, loadProject, saveProject, newProject} from "./project-utils";
import {Provider} from 'react-redux';
import {store} from './redux/store';
import {getCurrentWindow, Menu, isDevMode, remote} from './electron-modules';
import {engineMessageTypeJSON, PythonExecutable} from "./executable";

const sendToMainWindow = (message, payload=null) => {
  const mainWindow = remote.getCurrentWindow();
  mainWindow.webContents.send(message, payload);
};

const generateTemplateList = () => {
  // Generate menu from templates
  let template = [fileMenu, toolsMenu] as any[];

  if (isDevMode) {
    template.push(debugMenu);
  }

  return template;
};

const fileMenu = {
  label: 'File',
  submenu: [
    {
      label: 'New Project',
      click: async () => {
        newProject();
      }
    },
    {
      label: 'Open Project',
      click: async () => {
        loadProject();
      }
    },
    {
      label: 'Save Project',
      click: async () => {
        saveProject();
      }
    },
    {
      label: 'Save Project as...',
      click: async () => {
        saveProjectAs();
      }
    },
    {type: 'separator'},
    {role: 'quit'}
  ]
};

const setToolAvailability = toolName => {
  const exe = new PythonExecutable();
  exe.run({
    command: ['--check-tool', toolName],
    onLine: (messageType, data) => {
      if (messageType === engineMessageTypeJSON) {
        let jsonData = JSON.parse(data);
        Menu.getApplicationMenu().items
          .find(item => item.id === 'tools').submenu.items
          .find(item => item.id === toolName).enabled = jsonData.available;
      }
    },
  });
};

const checkViewerLicense = () => {
  if (!isDevMode) {
    // Keep track of viewer usage
    let exe = new PythonExecutable();
    exe.run({command: ['--viewer']});
  }
};

const toolsMenu = {
  label: 'Tools',
  id: 'tools',
  submenu: [
    {
      id: 'projections',
      label: 'Projections Manager',
      click: async () => {
        sendToMainWindow("open-projection-manager");
      }
    },
    {
      id: 'aligner',
      label: 'Image Aligner (Advanced)',
      enabled: false,
      click: async () => {
        sendToMainWindow("open-image-aligner-adv");
      }
    },
    {
      id: 'aligner-basic',
      label: 'Image Aligner (Basic)',
      enabled: false,
      click: async () => {
        sendToMainWindow("open-image-aligner-basic");
      }
    },
    {
      id: 'exporter',
      label: 'Export Static HTML',
      enabled: false,
      click: async () => {
        sendToMainWindow("open-static-export");
      }
    }
  ]
};

const debugMenu = {
  label: 'Refresh',
  click: () => {
    getCurrentWindow().reload();
  }
};

if (Menu) {
  const template = generateTemplateList();
  const menu = Menu.buildFromTemplate(template);
  Menu.setApplicationMenu(menu);

  setToolAvailability('aligner');
  setToolAvailability('aligner-basic');
  setToolAvailability('exporter');
  checkViewerLicense();
}

ReactDOM.render(
  <Provider store={store}>
    <App/>
  </Provider>,
  document.getElementById('root')
);